import { LoadingOutlined } from "@ant-design/icons";
import { Col, Container, Row } from "react-bootstrap";
interface LoadingSectionProps{
    text: string;
}

const LoadingSection: React.FC<LoadingSectionProps> = (props) => {

    return(
        <Container
            className="pt-3 d-flex justify-content-center align-items-center vstack"
        >
            <Row className="mb-5">
            <Col>
                <h2>
                    {props.text}
                </h2>
                <h2 className="d-flex justify-content-center align items-center">
                    <LoadingOutlined className="px-2"/>
                </h2>
            </Col>
            </Row>
        </Container>
    )
}

export default LoadingSection;